import { render, staticRenderFns } from "./DashboardModule.vue?vue&type=template&id=9e5dda34"
import script from "./DashboardModule.vue?vue&type=script&lang=js"
export * from "./DashboardModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports